import { render, staticRenderFns } from "./order-over.vue?vue&type=template&id=798404f4&scoped=true&"
import script from "./order-over.vue?vue&type=script&lang=js&"
export * from "./order-over.vue?vue&type=script&lang=js&"
import style0 from "./order-over.vue?vue&type=style&index=0&id=798404f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798404f4",
  null
  
)

export default component.exports